import { InjectionToken } from "@angular/core";

export type AppRuntimeMode = "dev" | "prod";

export interface AppConfig {
  readonly runtimeMode: AppRuntimeMode;
  readonly showStartScreen: boolean;
  readonly audioMutedByDefault: boolean;
}

function resolveRuntimeMode(): AppRuntimeMode {
  return import.meta.env.MODE === "prod" ||
    import.meta.env.MODE === "production"
    ? "prod"
    : "dev";
}

export const APP_CONFIG = new InjectionToken<AppConfig>("APP_CONFIG", {
  providedIn: "root",
  factory: () => {
    const runtimeMode = resolveRuntimeMode();
    return {
      runtimeMode,
      showStartScreen: runtimeMode === "prod",
      audioMutedByDefault: runtimeMode !== "prod",
    };
  },
});
